import React from 'react';
import { StarIcon as StarSolid } from '@heroicons/react/24/solid';
import { StarIcon as StarOutline } from '@heroicons/react/24/outline';

export function StarRating({ rating, size = 16 }) {
  return (
    <div className="feedback-stars">
      {[1, 2, 3, 4, 5].map(i => (
        <span key={i} className={`star ${i <= rating ? 'filled' : ''}`} style={{ fontSize: size }}>
          {i <= rating ? <StarSolid style={{ width: size, height: size }} /> : <StarOutline style={{ width: size, height: size }} />}
        </span>
      ))}
    </div>
  );
}

export function StarInput({ value, onChange }) {
  return (
    <div className="star-input">
      {[1, 2, 3, 4, 5].map(i => (
        <button
          key={i}
          type="button"
          className={`star-btn ${i <= value ? 'active' : ''}`}
          onClick={() => onChange(i)}
        >
          {i <= value ? <StarSolid style={{ width: 24, height: 24 }} /> : <StarOutline style={{ width: 24, height: 24 }} />}
        </button>
      ))}
    </div>
  );
}
